<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    @for (bc of breadcrumbService.breadcrumbs(); track bc; let i = $index) {
      <li
        class="breadcrumb-item {{i == breadcrumbService.breadcrumbs().length-1 ? 'active' : null}}">
        @if (bc.loading) {
          <app-spinner [grow]="true"></app-spinner>
        } @else {
          @if (i < breadcrumbService.breadcrumbs().length-1) {
            <a [routerLink]="bc.path">
              {{ bc.text|translate }}
            </a>
          } @else {
            {{ bc.text|translate }}
          }
        }
      </li>
    }
  </ol>
</nav>
